export const AuthorizationScheme = Object.freeze({
    OAUTH2: 'oauth2',
    API_KEY: 'apikey',
    BASIC_AUTH: 'basicAuth',
});

export const WebServiceType = Object.freeze({
    RESTFUL_API: 'Restful API',
    SOAP: 'SOAP',
    SFTP: 'sftp',
});

export const GrantType = Object.freeze({
    CLIENT_CREDENTIALS: 'client_credentials',
    PASSWORD: 'password'
});

export const ComplionClientPublicSettingFormFields = ['complionAuth0ClientId'];

export const AuthSchemeFormFields = Object.freeze({
    [AuthorizationScheme.OAUTH2]:
        ['authorizationScheme', 'tokenUrl', 'clientId', 'secret', 'audience', 'scope', 'username', 'password'],
    [AuthorizationScheme.API_KEY]: ['authorizationScheme', 'apiKey'],
    [AuthorizationScheme.BASIC_AUTH]: ['authorizationScheme', 'username', 'password'],
});

export const WebServiceFormFields = Object.freeze({
    [WebServiceType.RESTFUL_API]: ['webServiceType', 'postDocumentUrl', 'putDocumentUrl'],
    [WebServiceType.SOAP]: ['webServiceType', 'postDocumentUrl', 'putDocumentUrl'],
    [WebServiceType.SFTP]: ['webServiceType', 'ftpServer', 'ftpPort', 'eventMountPath'],
});
